import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomSelect, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import {
  CATEGORY_MEDIA_GET,
  CATEGORY_MEDIA_RESET,
} from '../../../../app/redux/actions/utils';
import { flattenCategories } from '../../../../utils/categories';
import {
  CardWrapper,
  ContentWrapper,
  Image,
  ImgCard,
  PaginationWrapper,
  ResultsWrapper,
  Thumbnail,
} from './style';
import Pagination from '../../Pagination';

const acceptedImgs = ['.jpg', '.jpeg', '.png'];
const acceptedFiles = ['.jpg', '.jpeg', '.png', '.mp4'];

export const ModalCategoryMediaId = 'ModalCategoryMedia';

const ModalCategoryMedia = ({
  mediaIsPhone,
  mediaIsTablet,
  isSupervisor,
  isAdmin,
  id,
  payload,
  categories,
  items,
  pager,
  modalClose,
  getCategoryMedia,
  resetCategoryMedia,
}) => {
  const scrollableAreaRef = useRef(null);
  const [img, setImg] = useState();
  const [file, setFile] = useState();
  const [selectedCategory, setSelectedCategory] = useState();

  useEffect(() => {
    return () => {
      if (id === ModalCategoryMediaId) {
        setImg();
        setFile();
        setSelectedCategory();
        resetCategoryMedia();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleGetCategoryMedia = (page) => {
    getCategoryMedia(selectedCategory?.id, {
      flag_multimedia: payload?.includeVideos,
      page,
    });
  };

  useEffect(() => {
    setImg();
    if (selectedCategory) {
      handleGetCategoryMedia();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);

  const loadMore = (page) => handleGetCategoryMedia(page);
  // const setItemsPerPage = (v) =>
  //   setSelectedFilters({ ...selectedFilters, items_per_page: v.value });

  const getURLByFile = (fl) => URL.createObjectURL(fl);

  return (
    <Modal
      title="Seleziona file"
      mbTitle={16}
      description="Seleziona l'area tematica per scegliere un media."
      modalId={ModalCategoryMediaId}
      scrollableAreaRef={scrollableAreaRef}
      className="max-size"
    >
      <ScrollableArea ref={scrollableAreaRef}>
        <ContentWrapper>
          {(isSupervisor || isAdmin) && (
            <div className="upload-box">
              <Text type="b3">
                Non trovi l’immagine adatta? Caricala direttamente dal tuo
                computer.
              </Text>
              <CTA
                id="upload-image"
                type="tertiary"
                btnText="Carica Immagine"
                icon="upload-01"
                onClick={(e) => {
                  const input = document.querySelector('#uploadFile');
                  input.click();
                }}
              />
              <input
                aria-labelledby="upload-image"
                className="d-none"
                type="file"
                id="uploadFile"
                accept={(payload?.includeVideos
                  ? acceptedFiles
                  : acceptedImgs
                ).join(',')}
                onChange={(e) => {
                  setImg();
                  setFile(e.target.files[0]);
                }}
              />
            </div>
          )}
          <div>
            <CustomSelect
              placeholder="Area tematica"
              options={flattenCategories(categories, 0, true)}
              size={mediaIsPhone ? 'full' : 'm'}
              onChange={(v) => setSelectedCategory(v)}
              menuPlacement="bottom"
            />
            <Text type="b3" mb={24} mt={24}>
              {pager?.total_items || 0} immagini
            </Text>
            <ResultsWrapper>
              <div className="img-list has-scrollbar">
                {(items || []).map((item) => (
                  <CardWrapper key={`img-${item.id}`}>
                    <ImgCard className={item?.id === img?.id ? 'active' : ''}>
                      <Thumbnail url={item?.url} />
                      <Text
                        type="h3"
                        className={
                          mediaIsPhone || mediaIsTablet ? '' : 'ellipsis'
                        }
                        onClick={() => setImg(item)}
                      >
                        {item.title}
                      </Text>
                    </ImgCard>
                  </CardWrapper>
                ))}
                {pager?.number_of_pages > 1 && (
                  <PaginationWrapper>
                    <Pagination
                      pager={pager}
                      callBack={loadMore}
                      hideGoToPage
                      pb={0}
                    />
                  </PaginationWrapper>
                )}
              </div>
              {!(mediaIsPhone || mediaIsTablet) && (
                <div className="img-box">
                  {img || file ? (
                    <div>
                      <Text type="h3.5" mb={16}>
                        {img?.title || file?.name}
                      </Text>
                      <Image url={img?.url || getURLByFile(file)} />
                    </div>
                  ) : (
                    <Text type="b3">Nessun immagine selezionata</Text>
                  )}
                </div>
              )}
            </ResultsWrapper>
          </div>
        </ContentWrapper>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="Inserisci"
          fullsize={mediaIsPhone}
          disabled={!img && !file}
          onClick={() => {
            payload?.onConfirm(img || file);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalCategoryMedia.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // state
  id: PropTypes.string,
  isSupervisor: PropTypes.bool,
  isAdmin: PropTypes.bool,
  items: PropTypes.array,
  categories: PropTypes.array,
  pager: PropTypes.object,
  payload: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getCategoryMedia: PropTypes.func,
  resetCategoryMedia: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { id, payload } = state.app.modal;
      const { isSupervisor, isAdmin } = state.user;
      const { categoriesAll: categories } = state.courselist;
      const {
        categoryMedia: { items, pager },
      } = state.utils;
      return { id, payload, isSupervisor, isAdmin, categories, items, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getCategoryMedia: (id, filters) =>
        dispatch({ type: CATEGORY_MEDIA_GET._REQUEST, id, filters }),
      resetCategoryMedia: () => dispatch({ type: CATEGORY_MEDIA_RESET }),
    })
  ),
  withMediaQueries
)(ModalCategoryMedia);
